import Element from 'ui/Element';
import mixin from 'privates/utils/mixin';
import HiddenCollapsedMixin from './mixins/HiddenCollapsedMixin';


/**
 * @mixin HiddenCollapsedElement
 * @summary Provides functionality for all elements that can be hidden or collapsed.
 * @mixes $w.Element
 * @mixes $w.HiddenCollapsedMixin
 * @memberof $w
 */
export default class HiddenCollapsedElement extends Element {
  constructor(RMI, compId, contextId, wixSelector, controllerId, role, type) {
    super(RMI, compId, contextId, wixSelector, controllerId, role, type);
    mixin(HiddenCollapsedElement.prototype, HiddenCollapsedMixin.prototype);
  }

  toJSON() {
    const {id, type, global, rendered} = this;
    return {id, type, global, rendered};
  }
}




// WEBPACK FOOTER //
// ./js/modules/ui/HiddenCollapsedElement.es6